<template>
  <div>
    <SalesReport type="products" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SalesReport from '@/modules/reports/components/SalesReport.vue';

export default defineComponent({
  name: 'Products',
  components: { SalesReport },
});
</script>
